import { parseEmbedTheme } from '../../../../packages/survey-core/src/embed-theme';
import type { EmbedTheme } from '@responsedock/types';

function decodeBase64Url(value: string): string {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
  return atob(`${normalized}${padding}`);
}

/**
 * Reads only visual tokens from the short-lived embed JWT so the host theme can
 * be painted before the authenticated embed session finishes loading. The API
 * still verifies the token before granting any access.
 */
export function readBootstrapEmbedTheme(search = window.location.search): EmbedTheme | null {
  try {
    const token = new URLSearchParams(search).get('embedToken');
    const payloadPart = token?.split('.')[1];
    if (!payloadPart) return null;
    const payload = JSON.parse(decodeBase64Url(payloadPart)) as { theme?: unknown };
    return parseEmbedTheme(payload.theme ?? {});
  } catch {
    return null;
  }
}
